import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  BrowserAnimationsModule,
  provideAnimations,
} from '@angular/platform-browser/animations';
import { ApiIntercepterService } from './Services/api-intercepter/api-intercepter.service';
import { ReloginDialogComponent } from './Modules/General/Modals/Relogin/relogin-dialog/relogin-dialog.component';
import { MaterialModule } from './Shared/material.module';
import { ToastrModule } from 'ngx-toastr';
import { SplashScreenComponent } from './Modules/Components/splash-screen/splash-screen.component';
import { LoginComponent } from './Modules/Components/login/login.component';
import { providePrimeNG } from 'primeng/config';
import { SelectModule } from 'primeng/select';
import Aura from '@primeng/themes/aura';
import { palette } from '@primeng/themes';
import { MatPrefix } from '@angular/material/form-field';
import { AppPreset } from './app.preset';
import { FloatLabelModule } from 'primeng/floatlabel';
import {
  MAT_DIALOG_DEFAULT_OPTIONS,
  MatDialogConfig,
} from '@angular/material/dialog';
const dialogDefaults: MatDialogConfig = {
  maxWidth: '90vw',
  minWidth: '0',
  autoFocus: false,
};
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SplashScreenComponent,
    ReloginDialogComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MaterialModule,
    FormsModule,
    DatePickerModule,
    FloatLabelModule,
    SelectModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      tapToDismiss: true,
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiIntercepterService,
      multi: true,
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: dialogDefaults,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: AppPreset,
        options: {
          darkModeSelector: '.app-dark',
          prefix: 'p',
          cssLayer: true,
        },
      },
    }),
  ],
})
export class AppModule {}
